package Structs

import myName

class Respone<K, V>(@myName("first") val first: K, @myName("second") val second: V) {

}